var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.person),function(item,key){return _c('van-cell',{key:key,attrs:{"title":item.name,"is-link":"","value":item.status ? '': '已评价'},on:{"click":function($event){return _vm.goTo(item)}}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }